import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { Email } from '../../graphql/emails.datatypes'
import {updateCacheByType} from "../../graphql/GraphQlProvider";

export interface UpdateEmailInput {
    data: {
        id: number;
        email: string;
    };
}

interface UpdateEmailData {
    updateEmail: Email;
}

export const UPDATE_EMAIL_MUTATION = gql`
  mutation updateEmail($data: UpdateEmailInput!){
    updateEmail(data: $data) {
      id
      email
    }
  }
`;

export const updateEmail = () => {
    return useMutation<UpdateEmailData, UpdateEmailInput>(
        UPDATE_EMAIL_MUTATION,
        {
            update: updateCacheByType('Email'),
        }
    );
};

export default updateEmail;
